import { DataWithPagination } from "services/api";
import { Pagination } from "services/search";
import { PaginationDirection } from "services/url";


export const initialVehicleManufacturerPagination: Pagination = {
    pageNumber: 1,
    pageSize: 1000,
    sort: {
      sortBy: 'created',
      direction: PaginationDirection.Descending,
    },
    totalCount: 1000,
    totalPages: 0,
  };

export const initialVehicleManufacturerDataWithPagination: DataWithPagination = {
  pagination: initialVehicleManufacturerPagination,
  data: [],
};


